export default __webpack_public_path__ + "images/mail-header.b91c16266fd0de7fb31d98eee3de7a43.png";